var _path, _rect, _rect2, _rect3, _path2, _rect4, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect5, _rect6, _rect7, _path10, _path11, _rect8, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZdoctorsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 54,
    viewBox: "0 0 163 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144.265 32.3769V24.9405C144.265 24.4828 144.494 24.3684 144.609 24.3684H147.011C148.293 24.3684 148.765 23.4532 148.842 22.9956V21.9659C148.842 20.593 147.774 20.1735 147.24 20.1354H144.265C140.032 20.1354 139.918 24.3684 139.918 24.3684V32.3769C139.918 33.5667 140.986 34.093 141.52 34.2074H142.549C143.465 34.2074 144.265 33.4066 144.265 32.3769Z",
    fill: "#1F7B9C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38.7852,
    y: 14.8728,
    width: 16.4746,
    height: 4.34746,
    rx: 2.17373,
    fill: "#1F7B9C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 37.7617,
    y: 32.1743,
    width: 22.4107,
    height: 4.43523,
    rx: 2.21761,
    transform: "rotate(-50.6956 37.7617 32.1743)",
    fill: "#1F7B9C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 38.5547,
    y: 29.7457,
    width: 16.7034,
    height: 4.34746,
    rx: 2.17373,
    fill: "#1F7B9C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.88 28.1619C109.105 28.6665 109.657 30.1694 108.929 31.2756C108.456 31.9944 107.97 32.5277 107.166 33.0264C105.72 33.9242 103.999 34.2719 102.318 34.0061C100.636 33.7402 99.1065 32.8786 98.0077 31.5785C96.9089 30.2783 96.3143 28.6264 96.3324 26.9242C96.3506 25.222 96.9803 23.5831 98.1066 22.3067C99.2329 21.0303 100.781 20.2015 102.467 19.9716C104.154 19.7417 105.867 20.1261 107.294 21.0545C108.405 21.7775 109.117 22.2047 109.323 23.8173C109.45 24.8084 108.692 25.6618 107.716 25.8753L107.489 25.9249C106.49 26.1435 105.752 25.2996 104.895 24.7417C104.353 24.3891 103.702 24.2431 103.061 24.3304C102.421 24.4177 101.833 24.7325 101.405 25.2173C100.977 25.7021 100.738 26.3246 100.731 26.9711C100.724 27.6176 100.95 28.2451 101.368 28.7389C101.785 29.2327 102.366 29.56 103.005 29.6609C103.643 29.7619 104.297 29.6298 104.846 29.2888C104.957 29.2201 105.065 29.123 105.17 29.0082C105.89 28.2203 106.894 27.7553 107.88 28.1619Z",
    fill: "#1F7B9C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 73.8086,
    y: 14.6439,
    width: 4.1066,
    height: 14.7464,
    rx: 2.0533,
    fill: "#1F7B9C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.8237 34.0569C74.7412 34.0569 77.9169 30.8812 77.9169 26.9637C77.9169 23.0462 74.7412 19.8705 70.8237 19.8705C66.9062 19.8705 63.7305 23.0462 63.7305 26.9637C63.7305 30.8812 66.9062 34.0569 70.8237 34.0569ZM70.8234 29.7636C72.3698 29.7636 73.6233 28.51 73.6233 26.9637C73.6233 25.4173 72.3698 24.1637 70.8234 24.1637C69.277 24.1637 68.0234 25.4173 68.0234 26.9637C68.0234 28.51 69.277 29.7636 70.8234 29.7636Z",
    fill: "#1F7B9C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.3003 34.0931C91.2177 34.0931 94.3935 30.9173 94.3935 26.9998C94.3935 23.0824 91.2177 19.9066 87.3003 19.9066C83.3828 19.9066 80.207 23.0824 80.207 26.9998C80.207 30.9173 83.3828 34.0931 87.3003 34.0931ZM87.3 29.7997C88.8463 29.7997 90.0999 28.5462 90.0999 26.9998C90.0999 25.4534 88.8463 24.1998 87.3 24.1998C85.7536 24.1998 84.5 25.4534 84.5 26.9998C84.5 28.5462 85.7536 29.7997 87.3 29.7997Z",
    fill: "#1F7B9C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.546 34.0931C134.464 34.0931 137.64 30.9173 137.64 26.9998C137.64 23.0824 134.464 19.9066 130.546 19.9066C126.629 19.9066 123.453 23.0824 123.453 26.9998C123.453 30.9173 126.629 34.0931 130.546 34.0931ZM130.546 29.7997C132.092 29.7997 133.346 28.5462 133.346 26.9998C133.346 25.4534 132.092 24.1998 130.546 24.1998C129 24.1998 127.746 25.4534 127.746 26.9998C127.746 28.5462 129 29.7997 130.546 29.7997Z",
    fill: "#1F7B9C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M121.389 31.805C121.389 33.0687 120.364 33.9787 119.101 33.9787C117.837 33.9787 116.812 33.0687 116.812 31.805C116.812 30.5413 116.812 29.6313 119.101 29.7457C120.364 29.7457 121.389 30.5413 121.389 31.805Z",
    fill: "#1F7B9C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M121.389 31.805C121.389 33.0687 120.364 34.0931 119.101 34.0931C117.837 34.0931 116.812 33.0687 116.812 31.805C116.812 30.5413 116.812 29.6313 119.101 29.7457C120.364 29.7457 121.389 30.5413 121.389 31.805Z",
    fill: "#1F7B9C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M118.87 34.0932C115.666 34.0932 113.836 31.233 113.836 30.0889V28.9448H117.963C118.027 29.7499 118.431 29.8951 118.641 29.8601L118.87 34.0932Z",
    fill: "#1F7B9C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M118.872 34.0932C114.296 34.0932 113.609 31.233 113.609 30.0889V28.9448H117.924C117.991 29.7499 118.413 29.8951 118.633 29.8601L118.872 34.0932Z",
    fill: "#1F7B9C"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 113.609,
    y: 14.8728,
    width: 4.57627,
    height: 16.9322,
    rx: 2.28814,
    fill: "#1F7B9C"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 121.613,
    y: 19.9066,
    width: 4.34746,
    height: 10.2966,
    rx: 2.17373,
    transform: "rotate(90 121.613 19.9066)",
    fill: "#1F7B9C"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 121.613,
    y: 19.9066,
    width: 4.34746,
    height: 10.2966,
    rx: 2.17373,
    transform: "rotate(90 121.613 19.9066)",
    fill: "#1F7B9C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M160.284 19.9066H153.992C151.933 19.9066 150.445 22.4236 150.445 23.682V24.0253V24.3685C150.445 27.2058 152.505 28.6015 153.305 28.7159C157.678 29.3406 158.568 29.5168 158.683 30.0888C158.754 30.4478 158.339 30.8897 158.111 30.8897H152.047C151.04 30.8897 150.789 32.11 150.789 32.7202C150.789 33.91 151.704 34.4363 152.161 34.5507H158.683C160.971 34.5507 162.344 32.6058 162.344 31.3473V29.4024C162.344 27.8464 161.2 26.4278 160.17 26.199L154.564 25.0549C153.42 24.7117 154.106 23.682 154.564 23.682H160.284C161.772 23.682 161.772 22.1948 161.772 22.1948V21.7371C161.772 19.9066 160.284 19.9066 160.284 19.9066Z",
    fill: "#1F7B9C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9576 40.1568C26.4647 40.1568 27.7135 38.9235 27.4184 37.4456C27.2419 36.5621 26.9792 35.6957 26.6327 34.8592C25.937 33.1797 24.9173 31.6536 23.6319 30.3682C22.3464 29.0827 20.8203 28.063 19.1408 27.3674C17.4613 26.6717 15.6611 26.3136 13.8432 26.3136C12.0253 26.3136 10.2252 26.6717 8.54565 27.3674C6.86611 28.063 5.34005 29.0827 4.05458 30.3682C2.76912 31.6536 1.74944 33.1797 1.05375 34.8592C0.707283 35.6957 0.444554 36.5621 0.26809 37.4456C-0.0270727 38.9235 1.22173 40.1568 2.72882 40.1568C4.2359 40.1568 5.41591 38.9039 5.89774 37.4759C5.95779 37.2979 6.02388 37.1218 6.09595 36.9478C6.51736 35.9304 7.13504 35.006 7.91372 34.2273C8.69239 33.4486 9.61681 32.831 10.6342 32.4095C11.6516 31.9881 12.742 31.7712 13.8432 31.7712C14.9444 31.7712 16.0349 31.9881 17.0522 32.4095C18.0696 32.831 18.994 33.4486 19.7727 34.2273C20.5514 35.006 21.1691 35.9304 21.5905 36.9478C21.6626 37.1218 21.7287 37.2979 21.7887 37.4759C22.2705 38.9039 23.4505 40.1568 24.9576 40.1568Z",
    fill: "#1F7B9C"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 17.6211,
    width: 5.0339,
    height: 18.0763,
    rx: 2.51695,
    fill: "#1F7B9C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9527 24.7119C18.7548 24.7119 22.6476 20.819 22.6476 16.0169C22.6476 11.2149 18.7548 7.32202 13.9527 7.32202C9.15066 7.32202 5.25781 11.2149 5.25781 16.0169C5.25781 20.819 9.15066 24.7119 13.9527 24.7119ZM13.9555 19.4491C15.8511 19.4491 17.3877 17.9125 17.3877 16.0169C17.3877 14.1214 15.8511 12.5847 13.9555 12.5847C12.06 12.5847 10.5233 14.1214 10.5233 16.0169C10.5233 17.9125 12.06 19.4491 13.9555 19.4491Z",
    fill: "#1F7B9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZdoctorsLogo);
export default __webpack_public_path__ + "static/media/ZdoctorsLogo.4bdff944e0356e92d451e071ed263946.svg";
export { ForwardRef as ReactComponent };